import { useSelector } from "react-redux";
import { selectOnlineOrdersConfigs } from "../../store/kitchen/kitchen.selector";
import DefaultMenuItem from "./default-menu-item.component.jsx";
import SquareMenuItem from "./square-menu-item.component.jsx";

const MenuItem = ({ product, kitchen }) => {
  const onlineOrdersConfig = useSelector(selectOnlineOrdersConfigs);
  const layout = onlineOrdersConfig?.menuItemCardLayout ?? "default";

  if (layout === "square") {
    return <SquareMenuItem product={product} kitchen={kitchen} />;
  }

  return <DefaultMenuItem product={product} kitchen={kitchen} />;
};

export default MenuItem;
